import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

interface BillingAccount {
  accountId: string
  siteIds: string[]
  pelloId: string
  name: string
}

const initialState: {
  token: string | null
  user: any | null
  mode: string
  selectedBillingAccounts: BillingAccount[]
} = {
  token: null,
  user: null,
  mode:
    localStorage.getItem('mode') ??
    (window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light'),
  selectedBillingAccounts: [],
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token
      state.user = action.payload.user
    },
    setToken: (state, action) => {
      state.token = action.payload
    },
    changeMode: (state) => {
      if (state.mode === 'light') {
        state.mode = 'dark'
        localStorage.setItem('mode', 'dark')
      } else {
        state.mode = 'light'
        localStorage.setItem('mode', 'light')
      }
    },
    updateSelectedAccounts(state, action: PayloadAction<BillingAccount[]>) {
      state.selectedBillingAccounts = action.payload
    },
    logout: (state) => {
      state.token = null
      state.user = null
      state.selectedBillingAccounts = []
    },
  },
})

export const selectSelectedBillingAccounts = (state: RootState) =>
  state.user.selectedBillingAccounts

export const selectedBillingAccountIds = createSelector(
  [selectSelectedBillingAccounts],
  (selectedBillingAccounts) => {
    return selectedBillingAccounts.map((account) => ({
      id: account.accountId,
      name: account.name,
      sites: account.siteIds,
    }))
  }
)

export const {
  setCredentials,
  setToken,
  changeMode,
  updateSelectedAccounts,
  logout,
} = userSlice.actions

export default userSlice.reducer
